<template>
  <div>
    <Button
      v-if="infoCtrl && isDetailLoad && editState" type="primary"
      style=" margin-left:310px ; float: left; margin-top: -64px;" @click="infoCtrl=false"
    >修改</Button>
    <Row v-if="!infoCtrl && isDetailLoad" class="case-form">
      <Form
        ref="formData" :model="formData"
        :rules="ruleValidate" :label-width="100"
      >
        <FormItem label="联调时间" prop="mediationDate">
          <DatePicker
            transfer
            type="date"
            placeholder="请选择联调时间"
            style="width:100%"
            format="yyyy-MM-dd"
            :value="formData.mediationDate"
            @on-change="getTime"
          />
        </FormItem>
        <FormItem label="联调案号" prop="caseNumber">
          <Input v-model="formData.caseNumber" placeholder="请输入联调案号" />
        </FormItem>
        <FormItem label="预计联调周期" prop="period">
          <Select
            v-model="formData.period" transfer
            placeholder="请选择预计联调周期"
          >
            <Option
              v-for="item in mediationPeriodArr" :key="item.id"
              :value="item.value"
            >{{ item.nameZh }}</Option>
          </Select>
        </FormItem>
      </Form>
      <Row class="detail-btn-box">
        <Button
          type="primary" style="margin-right:10px;"
          :disabled="isSubmit" @click="submitNew"
        >保存</Button>
        <Button v-if="defaultData" @click="infoCtrl=true">取消</Button>
      </Row>
    </Row>
    <Row v-if="infoCtrl&&isDetailLoad" class="detail-content">
      <Row><Col span="5" class="left-label">联调时间：</Col><Col span="16" class="right-content">{{ defaultData.mediationDate }}</Col></Row>
      <Row><Col span="5" class="left-label">联调案号：</Col><Col span="16" class="right-content">{{ defaultData.caseNumber }}</Col></Row>
      <Row><Col span="5" class="left-label">预计联调周期：</Col><Col span="16" class="right-content">{{ defaultData.periodName }}</Col></Row>
    </Row>
  </div>
</template>
<script>
export default {
  components: {},
  props: ['processId', 'caseId', 'editState'],
  data () {
    return {
      infoCtrl: false,
      isDetailLoad: false,
      isSubmit: false,
      defaultData: '',
      mediationPeriodArr: [],
      formData: {
        mediationDate: '',
        caseNumber: '',
        period: ''
      },
      ruleValidate: {
        mediationDate: [{ required: true, message: '联调时间不能为空', trigger: 'blur' }],
        caseNumber: [{ required: true, message: '联调案号不能为空', trigger: 'blur' }, { max: 32, message: '不能超过32个字符', trigger: 'blur' }]
      }
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    this.getDictionary()
    this.getDetail()
  },
  mounted() {},
  updated() {},
  methods: {
    // 获取诉前联调详情
    getDetail() {
      const url = '/business/case/mediation?type=BL&processId=' + this.processId
      this.$get(url).then(res => {
        if (res.code == 0 && res.data) {
          this.defaultData = res.data
          this.infoCtrl = true
          this.giveDefaultData()
        } else {
          this.defaultData = ''
          this.infoCtrl = false
          this.isDetailLoad = true
        }
      })
    },
    getTime(value) {
      this.formData.mediationDate = value
    },
    // 赋值
    giveDefaultData() {
      this.formData.mediationDate = this.defaultData.mediationDate
      this.formData.caseNumber = this.defaultData.caseNumber
      this.formData.period = this.defaultData.period

      this.isDetailLoad = true
    },
    submitNew() {
      let url = '/business/case/mediation'
      const ajaxData = {
        processId: this.processId,
        caseId: this.caseId
      }
      Object.assign(ajaxData, this.formData)
      if (this.defaultData) {
        url += `/${this.defaultData.id}`
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$patch(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      } else {
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      }
    },
    // 数据字典
    async getDictionary() {
      this.mediationPeriodArr = await this.common.getDictionaryItems('mediation_period')
    }
  }
}
</script>
<style scoped lang="scss">
@import "../caseCommon.scss";
.add-btn{
    margin-top:-64px;
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/prosecute/mediateBeforeSue.vue